import * as React from "react"

// Converted using https://www.smooth-code.com/open-source/svgr/playground/

export const PictoProducer = (props: any) => (
  <svg width="1.7em" height="1.7em" viewBox="0 0 200 200" {...props}>
    <path
      fill={props.color}
      d="M191.894 192.894H7.106V8.106h184.788v184.788zm-160-24.788h135.212V32.894H31.894v135.212z"
    />
  </svg>
)
